import React from "react";

const SkipToMain = () => {
  return (
    <a href="#main" className="skip-to-main">
      Skip to Main Content
    </a>
  );
};

export default SkipToMain;
